module.exports = __webpack_public_path__ + "static/Apercu-MediumItalic-c3a546dbf30e561586beb4232253c27f.svg";